import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const RouterLink = styled(Link)``;
export const HtmlLink = styled.a``;
